import script from "./FlipAsIs.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlipAsIs.vue?vue&type=script&lang=ts&setup=true"

import "./FlipAsIs.vue?vue&type=style&index=0&id=524dd6db&lang=scss"

const __exports__ = script;

export default __exports__